<template>
  <div @click="checkoutTabsHandle(cardData.status)" class="all-type-show-card">
    <div class="one">
      <div class="top">{{ cardData.presentee }}</div>

      <div class="bottom" v-if="cardData.adviserName">
        <img
          :src="require('../../../../../../common/images/oldnew/customer.png')"
          alt=""
        />
        <div class="text">{{ cardData.adviserName }}</div>
      </div>
    </div>
    <div class="two">
      <div class="top">{{ cardData.contactNumber }}</div>

      <div class="bottom">推荐人：{{ cardData.recUsername }}</div>
    </div>

    <div class="three">
      <div class="top"></div>
      <div
        class="bottom"
        v-if="parseJsonString[0] || parseJsonString[1] || parseJsonString[2]"
      >
        <div v-if="parseJsonString[0] && parseJsonString[0].propertyValue">
          {{ parseJsonString[0] && parseJsonString[0].propertyValue }}
        </div>
        <div v-if="parseJsonString[1] && parseJsonString[1].propertyValue">
          {{ parseJsonString[1] && parseJsonString[1].propertyValue }}
        </div>
        <div v-if="parseJsonString[2] && parseJsonString[2].propertyValue">
          {{ parseJsonString[2] && parseJsonString[2].propertyValue }}
        </div>
      </div>
    </div>
    <!-- status -->
    <div
      class="status"
      :style="{ backgroundColor: getStatusText(cardData.status).color }"
    >
      {{ getStatusText(cardData.status).text }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    checkoutTabsHandle(_status) {
      let oldMapNewStatus = {
        "0": -3,
        "1": -5,
        "2": -1,
        "3": 0,
        "4": 1,
        "5": 3,
        "6": 2,
        "7": 4,
      };
      let status = oldMapNewStatus[`${_status}`];
      // 根据type区分客户端
      //销售经理端
      if (this.$route.query.type == 1) {
        if ([-1, 0, 1, 2, 3, 4].includes(status)) {
          this.$parent.$parent.changeFollowActive(status);
          this.$emit("checkoutBig", 3);
        } else if (status == -3 || status == -4) {
          this.$parent.$parent.changeTrialActive(status);
          this.$emit("checkoutBig", 4);
        } else if (status == -5) {
          this.$emit("checkoutBig", -5);
        }
        // 置业顾问端
      } else if (this.$route.query.type == 2) {
        this.$emit("checkoutAdviser", status);
      }
    },
    getStatusText(status) {
      let oldMapNewStatus = {
        "0": "-3",
        "1": "-5",
        "2": "-1",
        "3": "0",
        "4": "1",
        "5": "3",
        "6": "2",
        "7": "4",
      };
      let map = {
        "-3": { color: "#C65050", text: "客户待审" },
        "-4": { color: "#C65050", text: "客户待审" },
        "-5": { color: "#D8A645", text: "客户分配" },
        "-2": { color: "#D8A645", text: "未处理" },
        "-1": { color: "#D8A645", text: "未处理" },
        "0": { color: "#D8A645", text: "未到访" },
        "1": { color: "#0D9869", text: "已到访" },
        "2": { color: "#0D9869", text: "已签约" },
        "3": { color: "#0D9869", text: "已认购" },
        "4": { color: "#C65050", text: "已失效" },
      };

      return map[`${oldMapNewStatus[`${status}`]}`] || {};
    },
  },
  computed: {
    parseJsonString() {
      let obj = (this.cardData.tagContents &&
        JSON.parse(this.cardData.tagContents)) || [{}];
      return obj;
    },
  },
};
</script>

<style lang="scss" scoped>
.all-type-show-card {
  margin: 0 4px;
  display: flex;
  align-items: center;
  height: 156px;
  background: #ffffff;

  box-shadow: 0px 4px 12px 0px rgba(164, 164, 164, 0.4);
  border-radius: 16px;
  margin-bottom: 30px;
  margin-top: 3px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 40px;
  position: relative;
  .one {
    margin-left: 30px;
    width: 100px;
    .top {
      max-width: 150px;
      width: 150px;
      overflow: hidden;
      height: 40px;
    }
    .bottom {
      margin-top: 22px;
      width: max-content;
      padding: 4px 16px;
      display: flex;
      align-items: center;
      background: #f9f4e8;
      border-radius: 0px 12px 12px 12px;
      img {
        width: 24px;
        height: 26px;
        margin-right: 8px;
      }
      .text {
        max-width: 100px;
        overflow: hidden;
        white-space: nowrap;
        max-height: 40px;
      }
    }
  }
  .two {
    margin: 0 60px 0 60px;
    width: 180px;
    .top {
      margin-bottom: 22px;
    }
    .bottom {
      width: max-content;
      max-width: 230px;
      height: 40px;
      overflow: hidden;
      padding: 0 16px;
      border-radius: 0px 12px 12px 12px;
      line-height: 40px;
    }
  }
  .three {
    .top {
      height: 40px;
      opacity: 0;
      margin-bottom: 22px;
    }
    .bottom {
      display: flex;
      div:nth-child(1) {
        width: 74px;
        height: 48px;
        background: #d8eee7;
        border-radius: 0px 12px 12px 12px;
        font-size: 24px;
        font-weight: 400;
        color: #007458;
        line-height: 48px;
        padding-left: 12px;
        overflow: hidden;
      }
      div:nth-child(2) {
        margin: 0 12px;
        width: 104px;
        height: 48px;
        background: #f6eed9;
        border-radius: 0px 12px 12px 12px;
        font-size: 24px;
        font-weight: 400;
        color: #d79414;
        line-height: 48px;
        padding-left: 12px;
        overflow: hidden;
      }
      div:nth-child(3) {
        width: 42px;
        height: 48px;
        background: #dde9f5;
        border-radius: 0px 12px 12px 12px;

        font-size: 24px;
        font-weight: 400;

        color: #5386b8;
        line-height: 48px;
        padding-left: 12px;
        overflow: hidden;
      }
    }
  }
  .status {
    position: absolute;
    background: #d8a645;
    border-radius: 0px 16px 0px 16px;

    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
    text-align: center;
    right: 0;
    top: 0;
    padding: 8px 12px;
  }
}
</style>
